<template>
  <span v-if="!isEdit" @click="onEdit">{{  format ? format(prop, data) : (data[nameProp || prop] || '-')}}</span>
  <component v-else :is="`el-${editType}`" v-model="data[prop]" v-bind="$attrs" @change="onChange" @blur="onChange">
    <template v-if="options">
      <el-option
        v-for="opt in options"
        :key="opt[valueMap]"
        :label="opt[labelMap]"
        :value="formatValue(opt[valueMap])"
      ></el-option>
    </template>
  </component>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    prop: String,
    nameProp: String,
    editType: {
      type: String,
      default: 'input'
    },
    valueMap: {
      type: String,
      default: 'value'
    },
    labelMap: {
      type: String,
      default: 'label'
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    options: Array,
    format: Function,
  },
  methods: {
    onEdit() {
      if (!this.disabled) {
        this.$emit('update:isEdit', true)
      }
    },
    onChange() {
      if (!this.disabled) {
        this.$emit('update:isEdit', false)
      }
      this.$emit('change', this.data)
    },
    formatValue(value) {
      if (!value) return value
      let type = typeof this.data[this.prop]
      switch(type) {
        case 'string':
          return value?.toString()
        case 'number':
          return Number(value)
        default:
          return value
      }
    }
  }
  
}
</script>